<template>
  <div class='admin-panel'>
    <header-base />
    <h1 v-if='!isAdmin'>YOU AREN'T ALLOWED TO ACCESS THIS PAGE. YOUR USERNAME WILL BE LOGGED AND ACTION MAY BE  TAKEN IF YOU REPEAT THIS.</h1>
    <div v-else>
      <h1>ADMIN POWERS ENABLED</h1>
      <v-expansion-panels multiple focusable :value='[0,1]'>
        <v-expansion-panel>
          <v-expansion-panel-header expand-icon='fa-angle-down'><h1>SCRAMBLE EDITOR</h1></v-expansion-panel-header>
          <v-expansion-panel-content>
            <scrambles-editor :roundID='roundID' :order='order' />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header expand-icon='fa-angle-down'><h1>UPDATE ROUND {{ roundID }} - change status</h1></v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-container>
              <v-row>
                <v-btn @click="updateRoundStatus('UPCOMING')">UPCOMING</v-btn>
                <v-btn @click="updateRoundStatus('OPEN')">OPEN</v-btn>
                <v-btn @click="updateRoundStatus('REVIEW')">REVIEW</v-btn>
                <v-btn @click="updateRoundStatus('CLOSED')">CLOSED</v-btn>
              </v-row>
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header expand-icon='fa-angle-down'><h1>CREATE EVENT</h1></v-expansion-panel-header>
          <v-expansion-panel-content>
            <event-creator />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header expand-icon='fa-angle-down'><h1>VIEW EMAILS {{roundID}}</h1></v-expansion-panel-header>
          <v-expansion-panel-content>
            <emails-viewer :roundID='roundID' />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-if='profileID'>
          <v-expansion-panel-header expand-icon='fa-angle-down'><h1>UPDATE TIMES - {{roundID}}, {{profileID}}</h1></v-expansion-panel-header>
          <v-expansion-panel-content>
            <time-updater :roundID='roundID' :profileID='profileID' />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>

<script>
import AdminService from '@/services/TPC/AdminService'

import HeaderBase from '@/components/TPC/Header/Base'
import ScramblesEditor from '@/components/TPC/Admin/ScramblesEditor'
import EventCreator from '@/components/TPC/Admin/EventCreator'
import TimeUpdater from '@/components/TPC/Admin/TimeUpdater'
import EmailsViewer from '@/components/TPC/Admin/EmailsViewer'

export default {
  name: 'admin-panel',
  components: {
    HeaderBase,
    ScramblesEditor,
    EventCreator,
    TimeUpdater,
    EmailsViewer,
  },
  data () {
    return {
      isAdmin: false,
    }
  },
  methods: {
    async updateRoundStatus (newStatus) {
      let confirmation = confirm(`Updating status to ${newStatus}. Confirm?`)
      if (!confirmation) return
      let {data} = await AdminService.updateRound({
        roundID: this.roundID,
        status: newStatus,
      })
      if (data.error) {
        return alert(`Error: ${data.error} - ${data.message}`)
      }
      if (data.success) {
        return alert('Success!')
      }
      alert(`Something went wrong and I don't know what: result - ${data}`)
    },
  },
  async created () {
    let resp = await AdminService.verifyAdmin()
    if (resp.data && resp.data.success) {
      this.isAdmin = true
    }
  },
  computed: {
    roundID () {
      const {rid, eid} = this.$route.query
      if (rid) return rid
      if (eid) return eid+'Rqual'
      return undefined
    },
    order () {
      const {sid} = this.$route.query
      if (!sid) return undefined
      const matches = sid.match(/(\d*)o(.*)/)
      if (!matches || !matches[2]) return undefined
      return parseInt(matches[2], 10)
    },
    profileID () {
      const {sid} = this.$route.query
      if (!sid) return undefined
      const matches = sid.match(/(\d*)o(.*)/)
      if (!matches || !matches[1]) return undefined
      return parseInt(matches[1], 10)
    }
  }
}
</script>

<style scoped>

</style>
